const indexItems = [
  { letter: 'A', title: '娱乐圈黑料合集', desc: '最新明星八卦、恋情曝光、私生活揭秘等娱乐行业相关黑料视频在线观看。', count: 1286 },
  { letter: 'B', title: '网红直播专区', desc: '各平台头部网红翻车实录、直播内幕、虚假宣传等黑料网在线播放内容。', count: 947 },
  { letter: 'C', title: '社会热点追踪', desc: '企业丑闻、社会事件、公共安全等热点话题的黑料在线观看深度报道。', count: 823 },
  { letter: 'D', title: '综艺幕后揭秘', desc: '热门综艺节目内幕、导演组操作、剪辑黑幕等黑料视频在线播放独家内容。', count: 652 },
  { letter: 'E', title: '商界风云录', desc: '知名企业高管丑闻、商业欺诈、内幕交易等财经类黑料网在线观看专题。', count: 534 },
  { letter: 'F', title: '音乐圈乱象', desc: '歌手抄袭争议、假唱实锤、版权纠纷等音乐行业的黑料在线看片内容。', count: 418 },
  { letter: 'G', title: '体坛爆料站', desc: '体育明星私生活、赛事黑幕、兴奋剂风波等体坛黑料视频在线播放。', count: 367 },
];

export default function IndexSection() {
  return (
    <section id="index" className="py-12 md:py-16 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-8 md:mb-10">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium mb-3">
            <i className="ri-bookmark-line"></i>
            内容导航
          </div>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground-950">
            专题索引
          </h2>
          <p className="text-sm md:text-base text-foreground-500 mt-2">
            按分类快速浏览黑料网下载全部内容板块
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {indexItems.slice(0, 6).map((item, i) => (
            <div
              key={i}
              className="group flex gap-4 p-5 rounded-xl bg-background-50 border border-secondary-200/60 hover:border-primary-200 transition-colors cursor-pointer"
            >
              <div className={`w-11 h-11 flex items-center justify-center rounded-xl shrink-0 font-heading text-lg font-bold ${
                i < 2 ? 'bg-primary-100 text-primary-600' :
                i < 4 ? 'bg-accent-100 text-accent-600' :
                'bg-secondary-100 text-secondary-600'
              }`}>
                {item.letter}
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-1">
                  <h3 className="text-sm md:text-base font-heading font-bold text-foreground-800 group-hover:text-primary-500 transition-colors">
                    {item.title}
                  </h3>
                </div>
                <p className="text-xs text-foreground-500 line-clamp-2 mb-2">
                  {item.desc}
                </p>
                <span className="text-xs text-foreground-400">
                  {item.count.toLocaleString()} 条内容
                </span>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-5">
          <div className="p-6 rounded-xl bg-gradient-to-r from-primary-500/10 to-accent-500/10 border border-primary-200/40">
            <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4">
              <div className="w-11 h-11 flex items-center justify-center rounded-xl bg-primary-100 shrink-0">
                <span className="text-lg font-heading font-bold text-primary-600">{indexItems[6].letter}</span>
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="text-sm md:text-base font-heading font-bold text-foreground-800 mb-1">
                  {indexItems[6].title}
                </h3>
                <p className="text-xs text-foreground-500">{indexItems[6].desc}</p>
              </div>
              <div className="flex items-center gap-2 shrink-0">
                <span className="text-sm text-foreground-400">{indexItems[6].count.toLocaleString()} 条内容</span>
                <span className="flex items-center gap-1 text-sm text-primary-500 font-medium cursor-pointer hover:gap-2 transition-all whitespace-nowrap">
                  进入浏览
                  <i className="ri-arrow-right-line"></i>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}